'use client';

import { useState } from 'react';

/**
 * Hook useLocalStorage.
 */
export const useLocalStorage = <T>(
  key: string,
  initialValue: T,
  notLoadedValue?: T,
) => {
  const [storedValue, setStoredValue] = useState<T>(() => {
    if (typeof window === 'undefined') {
      return notLoadedValue !== undefined ? notLoadedValue : initialValue;
    }
    try {
      const item = window.localStorage.getItem(key);
      return item ? JSON.parse(item) : initialValue;
    } catch {
      return initialValue;
    }
  });

  const setValue = (value: T | ((val: T) => T)) => {
    try {
      setStoredValue(value);
      if (typeof window !== 'undefined') {
        window.localStorage.setItem(key, JSON.stringify(value));
      }
    } catch {
      /**/
    }
  };
  return [storedValue, setValue] as const;
};
